export default "__VITE_ASSET__BuBZhJWb__"